import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { AccountShipToCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { AccountShipToModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";
import omit from "lodash/omit";

export interface CustomAccountShipTosState {
    readonly dataViews: SafeDictionary<DataView>;
}

interface DataView {
    properties: any;
    readonly isLoading: boolean;
    pagination: PaginationModel | null;
    value?: AccountShipToModel[];
}

const initialState: CustomAccountShipTosState = {
    dataViews: {},
};

const CustomAccountShipToReducer = {
    "Custom/AccountShipTos/CompleteSearchAccountShipToCollectionUpdated": (
        draft: Draft<CustomAccountShipTosState>,
        action: { parameter: any; collection: AccountShipToCollectionModel },
    ) => {
        const dataView = {
            isLoading: false,
            value: action.collection.userShipToCollection!,
            pagination: action.collection.pagination,
            properties: action.collection.properties,
        };
        const filter = action.parameter.additionalQueryStringParameters?.filter || "";
        const keyParameter = { ...omit(action.parameter, "additionalQueryStringParameters"), filter };
        draft.dataViews[getDataViewKey(keyParameter)] = dataView;
    },
};

export default createTypedReducerWithImmer(initialState, CustomAccountShipToReducer);
